export default __webpack_public_path__ + "static/media/ruby-plain.9d993984.svg";